(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDialogQueryController', WarningDialogQueryController);

    WarningDialogQueryController.$inject = ['$scope', '$stateParams', '$state', 'AlertService', 'Warning'];

    function WarningDialogQueryController($scope, $stateParams, $state, AlertService, Warning) {
        var vm = this;

        vm.showQuery = "";
        vm.query = [];
        vm.notQuery = false;
        vm.lastIndex = null;
        vm.hasTotalNegation= false;
        vm.memory = [];
        vm.originalQuery = localStorage.getItem("originalQuery");

        var warning = localStorage.getItem("edit-automatic-rule");
        var query = "";
        if(warning != null && warning != "null" && warning != undefined){
            vm.warning = JSON.parse(warning);
            query = vm.warning.query;
        }
        if(query != null){
            vm.showQuery = query.replace(/\s\s+/g, ' ');
            //  aggiorno showQuery basata su originalQuery
            updateShowQuery();
            query = vm.showQuery.split(" ");
            query = checkQuery(query);
            var limit = query.length;
            for(var i = 0; i < limit; i++){
                if(query[i+1] === "TO"){
                    query[i] = query[i]+" "+query[i+1]+" "+query[i+2];
                    query.splice(i+1, 2);
                }
            }
            for(var i = 0; i < query.length; i++){
                var app = {};
                app.value = query[i];
                app.level = 0;
                vm.query.push(app);
            }
            app = {};
            app.query = vm.showQuery;
            app.components = JSON.stringify(vm.query);
            app.negative = false;
            vm.memory.push(app);
            vm.viewIndex = vm.memory.length-1;
        }


        function updateShowQuery() {
            var storedValue = localStorage.getItem("originalQuery");
            if (!storedValue) return;

            var originalQuery = JSON.parse(storedValue).trim().replace(/^\\\\*"\\s*|\\s*"\\\\*$/g, '');
            var hasTotalNegation = /^!\(.*\)$/.test(originalQuery);

            if (hasTotalNegation && !vm.showQuery.startsWith("!(") && !vm.showQuery.endsWith(")")) {
                vm.showQuery = "!(" + vm.showQuery + ")";
            }
            vm.hasTotalNegation = hasTotalNegation;
        }
        function checkQuery(query) {
            for(var i = 0;  i < query.length; i++){
                if(query[i].length == 0) {
                    query.splice(i, 1);
                }
            }
            return query;
        }

        vm.moveInside = function(index) {
            if(index%2==0){
                if(vm.lastIndex == null || vm.lastIndex != index){
                    if(vm.lastIndex != index-1 && vm.lastIndex != index+1){
                        moveIndex(index);
                        vm.lastIndex = index;
                    } else {
                        AlertService.error("Error Edit Group");
                    }
                } else {
                    AlertService.error("Error Edit Group");
                }
            } else {
                if(vm.lastIndex == null || vm.lastIndex != index){
                    moveIndex(index);
                    vm.lastIndex = index;
                } else {
                    AlertService.error("Error Edit Group");
                }
            }
            app = {};
            app.query = vm.showQuery;
            app.components = JSON.stringify(vm.query);
            app.neagative = false;
            vm.memory.push(app);
            vm.viewIndex = vm.memory.length-1;
        };

        function moveIndex(index){
            if(index%2 == 0){
                move(index);
            } else {
                if(vm.query[index-1].level-1 == vm.query[index].level){
                    if(vm.query[index].level == vm.query[index+1].level){
                        move(index);
                        move(index+1);
                    } else {
                        AlertService.error("Cannot move this operator");
                    }
                } else {
                    if(vm.query[index-1].level == vm.query[index+1].level){
                        if(vm.query[index].level == vm.query[index+1].level){
                            move(index-1);
                            move(index);
                            move(index+1);
                        } else {
                            AlertService.error("Error Edit");
                        }
                    }
                }
            }
        }

        function move(index) {
            vm.query[index].level++;
            if(index != 0){
                if(vm.query[index-1].level == vm.query[index].level){
                    if(index != vm.query.length-1){
                        if (vm.query[index+1].level == vm.query[index].level) {
                            vm.query[index+1].value = vm.query[index-1].value.substring(1, vm.query[index-1].value.length);
                            vm.query[index].value = "(" + vm.query[index].value;
                        } else {
                            vm.query[index-1].value = vm.query[index-1].value.substring(0, vm.query[index-1].value.length-1);
                            vm.query[index].value = vm.query[index].value + ")";
                        }
                    } else {
                        vm.query[index-1].value = vm.query[index-1].value.substring(0, vm.query[index-1].value.length-1);
                        vm.query[index].value = vm.query[index].value + ")";
                    }
                } else {
                    vm.query[index].value = "(" + vm.query[index].value + ")";
                }
            } else {
                vm.query[index].value = "(" + vm.query[index].value + ")";
            }
            vm.showQuery = "";
            for(var i = 0; i < vm.query.length; i++){
                if(i == vm.query.length-1){
                    vm.showQuery += vm.query[i].value;
                } else {
                    vm.showQuery += vm.query[i].value+" ";
                }
            }
        }

     /*   vm.negQuery = function() {
            vm.notQuery = !vm.notQuery;
            if(vm.showQuery[vm.showQuery.length-1] === " "){
                vm.showQuery = vm.showQuery.substring(0, vm.showQuery.length-1);
            }
            if(vm.notQuery){
                vm.showQuery = "!(" + vm.showQuery + ")";
                app = {};
                app.query = vm.showQuery;
                app.components = JSON.stringify(vm.query);
                app.negative = vm.notQuery;

                vm.memory.push(app);
                vm.viewIndex = vm.memory.length-1;
            } else {
                /!*vm.showQuery = vm.showQuery.substring(2, vm.showQuery.length-1);*!/
                app = {};
                app.query = vm.showQuery;
                app.components = JSON.stringify(vm.query);
                app.negative = vm.notQuery;
                vm.memory.push(app);
                vm.viewIndex = vm.memory.length-1;
            }
        };*/

        vm.negQuery = function() {
            if (!vm.hasTotalNegation) {
                vm.showQuery = "!(" + vm.showQuery + ")";
                vm.hasTotalNegation = true;
            } else {
                vm.showQuery = vm.showQuery.substring(2, vm.showQuery.length - 1);
                vm.hasTotalNegation = false;
            }
            var app = {
                query: vm.showQuery,
                components: JSON.stringify(vm.query),
                negative: vm.hasTotalNegation
            };
            vm.memory.push(app);
            vm.viewIndex = vm.memory.length - 1;
        };

        vm.addNegQuery = function() {
            vm.showQuery = vm.showQuery.startsWith("!(") && vm.showQuery.endsWith(")")
                ? vm.showQuery.slice(2, -1)
                : "!(" + vm.showQuery + ")";
            vm.hasTotalNegation = !vm.hasTotalNegation;
            vm.memory.push({
                query: vm.showQuery,
                components: JSON.stringify(vm.query),
                negative: vm.hasTotalNegation
            });
            vm.viewIndex = vm.memory.length - 1;
        };



        vm.save = function () {
            vm.isSaving = true;
            vm.warning.query = vm.showQuery;
            vm.warning.composed = true;
            vm.warning.active = false;
            if(vm.warning.action != null && vm.warning.action.id == -1 ) {
                vm.warning.action = null;
            }
            if(vm.warning.macro != null && vm.warning.macro.id == -1 ) {
                vm.warning.macro = null;
            }

            if (vm.warning.id !== null) {
                Warning.update(vm.warning, onSaveSuccess, onSaveError);
            } else {
                vm.fleetsTosave = vm.warning.tabFleets;
                vm.isSaving = true;
                vm.saveByFleet();
            }
        };

        vm.saveByFleet = function() {
            vm.warning.tabFleets = vm.fleetsTosave[0];
            vm.fleetsTosave.splice(0, 1);
            Warning.save(vm.warning, onSaveSuccess, onSaveError);
        };

        var onSaveSuccess = function (result) {
            if(vm.fleetsTosave != null || vm.fleetsTosave != undefined){
                if (vm.fleetsTosave.length > 0) {
                    vm.saveByFleet();
                } else {
                    $scope.$emit('jotApp:warningUpdate', result);
                    vm.isSaving = false;
                    $state.go('warning');
                }
            } else {
                $scope.$emit('jotApp:warningUpdate', result);
                vm.isSaving = false;
                $state.go('warning');
            }
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.clear = function() {
            $state.reload();
        };

        vm.useMemory = function (goBack) {
            if(goBack){
                vm.viewIndex--;
            } else {
                vm.viewIndex++;
            }
            vm.showQuery = vm.memory[vm.viewIndex].query;
            vm.query = JSON.parse(vm.memory[vm.viewIndex].components);
            vm.notQuery = vm.memory[vm.viewIndex].negative;
        };

    }
})();
